module.exports = __webpack_public_path__ + "fonts/SalesforceSans-Bold.1a99b4b58efca0b3c1b1ea9c29d981e4.woff";